import React, { Component } from "react";
import styled from "styled-components";

export default class Logo extends Component {
   render() {
      let LogoBody = styled.div`
      position: relative;
z-index: 10;
font-size: ${this.props.options['fontSize']};

`

      let Logotext = styled.span`
font-family: 'Bebas Neue';
text-transform: uppercase;
color: ${this.props.options['colorFont']};
`
      let LogoTriangle = styled.span`
margin: 0em 0.05em;
display: inline-block;
height: 0px;
width: 0px;
border-bottom: 0.35em solid transparent;
border-top: 0.35em solid transparent;
border-right: 0.28em solid ${this.props.options['colorTriangel']};
`

      return (
         <LogoBody>
            <Logotext>Konstru</Logotext>
            <LogoTriangle></LogoTriangle>
            <Logotext>t</Logotext>
         </LogoBody>
      )
   }


}

/*
пример:
render(){
   let color = {
      colorFont: 'rgba(255, 255, 255, 1)',
      colorTriangel: 'rgba(0, 164, 229, 1)',
      fontSize: '1.43rem'
   };

   return(
      <Logo options={color}/>
   )
}*/